<template>
  <section id="other-packages">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <div class="title">
            <h2>Pakot</h2>
            <h5>Keto pako jane ne dispozicionin tuaj, zgjidhni ate qe ju pershtatet me se shumti</h5>
          </div>
        </div>
        <div v-for="offer in offers" :key="offer.name" class="col-lg-4 col-md-4 col-sm-12 pb-3">
          <div v-if="offer.id !== packageTypeId.PERSONALE" class="items">
            <h3>{{ offer.name }}</h3>
            <hr>
            <ul v-if="offer.id===packageTypeId.KOSOVA" class="name">
              <li :key="item" v-for="item in getPackageSecondaryDescriptionContent(packageTypeId.KOSOVA)">{{ item.trim()}}</li>
            </ul>
            <ul v-if="offer.id===packageTypeId.BALLKANI" class="name">
              <li :key="item" v-for="item in getPackageSecondaryDescriptionContent(packageTypeId.BALLKANI)">{{ item.trim()}}</li>
            </ul>
            <ul v-if="offer.id===packageTypeId.EVROPA" class="name">
              <li :key="item" v-for="item in getPackageSecondaryDescriptionContent(packageTypeId.EVROPA)">{{ item.trim()}}</li>
            </ul>
            <div class="price">
              <strong>{{ calculatePackagePrice(offer.id, packageTypeEnum.ANNUAL, currentPromotion) }}€</strong>
              <span>vjetore</span>
            </div>
            <router-link
                :to="`billing/${offer.id}/${packageTypeEnum.ANNUAL}`"
                tag="a"
                class="nav-link"
                @click="getSelectedPackage(offer.id, $event)"
            >
              zgjedh pakon
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style src="@/assets/client/css/main.css">
</style>

<script>
import { mapGetters } from "vuex";
import { calculatePackagePrice } from "../utils";
import { packageDescriptionContent } from "../packageDescriptionContent";
import { packageTypeEnum, packageTypeId } from "../enums/enum";

export default {
  name: "Offers",
  computed: {
    ...mapGetters({
      offers: "subscriptions/offers",
      currentPromotion: "account/currentPromotion",
    }),
    getPackageSecondaryDescriptionContent() {
      return (offerId) => {
        const content = this.packageDescriptionContent[offerId];
        return content ? content.secondary_content.split('.').filter(item => item.trim()) : [];
      };
    },
  },
  data() {
    return {
      packageDescriptionContent: packageDescriptionContent,
      packageTypeEnum: packageTypeEnum,
      packageTypeId: packageTypeId
    }
  },
  methods: {
    calculatePackagePrice,
    getSelectedPackage(pack, e) {
      e.preventDefault();
      this.$store.dispatch("selected/getSelectedPackage", {
        value: pack,
        router: this.$router
      });
    }
  },
  beforeMount() {
    this.$store.dispatch("subscriptions/getOffers");
  }
};
</script>
